'use client';

import clsx from 'clsx';
import { FC, useState } from 'react';

import { Icon } from 'src/general/Icons/Icon';

interface Props {
  weeklyRepayment: string;
  defaultRate: string;
}

export const ProductCardRepaymentsTooltip: FC<Props> = ({ weeklyRepayment, defaultRate }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative z-10 inline-block">
      <button
        className="pointer-events-auto -m-3 size-10 p-3"
        title="More info"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
      >
        <Icon name="info-circle-empty" size={16} />
      </button>
      {isOpen && (
        <div
          className={clsx(
            'pointer-events-none absolute right-0 bottom-full flex w-60 translate-x-22 flex-col gap-2 rounded-md bg-for-neu-inv p-2 px-3 py-2 text-tex-inv-tie1 shadow-elevation-24dp duration-150 starting:opacity-0 starting:transition-opacity',
          )}
        >
          <h4 className="c-fs-caption font-extrabold">Weekly payment of {weeklyRepayment}</h4>
          <div className="c-fs-caption">
            The weekly payment of {weeklyRepayment} is based on payment over a 5 year term at an average rate of{' '}
            {defaultRate} p.a. Fees and charges apply^
          </div>
        </div>
      )}
    </div>
  );
};
